import TextCard from 'Components/Reusable/Cards/TextCard';
import React, { Fragment, useEffect, useState } from 'react';
import { BackButton, CommonButton } from 'Components/Reusable/Buttons/Buttons';
import Error from '../Timeline/Error';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// redux and store imports
import { RootState } from 'ReduxStore/store';
import { generateNewToy, getToy, issueWithToy } from 'ReduxStore/toys/Action';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from '../Timeline/timeline.style';
import { Routes } from 'Utils/Route';
import { useHistory, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { changeIdentities, setExerciseImage, shuffleItems } from 'Helpers';
import { ClipLoader } from 'react-spinners';
import { GetExerciseById } from 'ReduxStore/exercises/Action';
import { getAgeGroup } from 'ReduxStore/milestones/Action';
import { GetAllKids } from 'ReduxStore/children/Action';
import backButton from 'Assets/img/svg/buttons/back.svg';

interface RouteParams {
	id: string;
}
const CalendarDetails = () => {
	
	const dispatch = useDispatch();
	const [loading, setLoading] = useState<boolean>(false)
	const classes = useStyles();
	const history = useHistory();
	const childName = localStorage.getItem('currentChild');
    const params = useParams<RouteParams>();
	useEffect(() => {
		setLoading(true)
        dispatch(GetExerciseById(params.id))
		dispatch(getAgeGroup())
		dispatch(GetAllKids());
		setLoading

	}, []);

	const errors = useSelector((state: RootState) => state.exercise['error']);
	const ageGroupData = useSelector((state:RootState) => state.milestones.ageGroup)
	const matches = useMediaQuery('(max-width:1169px)');
	const children = useSelector((state: RootState) => state.children.children);
    const exerciseDetails:any = useSelector((state:RootState) => state.exercise['exercise'])
	const blocks = [
		'#86E3CE',
		'#D0E6A5',
		'#FFDD95',
		'#FC887B',
		'#A9BAF2',
	];


	const getChildId = JSON.parse(localStorage.getItem('currentChildId') || '{}');
	const child = children && children.find(child => child.id === parseInt(getChildId));
	const redirectToNewToy = ( toyLink:any) => {
		return window.open(toyLink, '_blank');
	}
	return (
		<Fragment>
			<BackButton image={backButton} transparent />
			{exerciseDetails && exerciseDetails ? (
				<div>

					<img className={classes.topImage}  src={exerciseDetails?.imageName && setExerciseImage(exerciseDetails?.imageName)} alt="" />
					<h3  className="d-flex justify-content-center align-items-center " style={{marginTop:'1rem',textAlign:'center'}}>{exerciseDetails?.title && changeIdentities(exerciseDetails?.title,child?.fullName,child?.gender)}</h3> 
					<h4 className={classes.goal}>{exerciseDetails?.Goal && changeIdentities(exerciseDetails?.Goal,child?.fullName,child?.gender)}</h4>
					<div className={classes.boxContainer}>
						<ul className={classes.boxA}>
							<li>AGE: {ageGroupData?.monthsMin} Months</li>
							<li>TIME: {exerciseDetails?.minutes} Minutes</li>
							<li style={{textAlign:'center'}}>{exerciseDetails?.frequency}</li>
						</ul>
						<ul className={classes.boxB}>
						</ul>
						{ <ul className={classes.boxC}>
							<li>{parse(exerciseDetails?.skills)}</li>
						</ul> }
					</div>
					{
						exerciseDetails?.supplies && (
							<section className={classes.redBoxContainer}>
						<h4 style={{padding:'1rem'}}>SUPPLIES</h4>
						<div className={classes.redBoxDiv}>
							<ul className={classes.supplies}>
								<li></li>
							</ul>
							<ul className={classes.supplies}>
								<li>{exerciseDetails?.supplies && parse(changeIdentities(exerciseDetails?.supplies,child?.fullName,child?.gender))}</li>
							</ul>
							<ul className={classes.supplies}>
								<li></li>
							</ul>
						</div>
					</section>
						)
					}
					<section>
						<div className="container pb-0">
							<div className="row">
								<div className="col-md-12 text-center">
									<div className="heading-line-bottom text-center">
										<h3 style={{ margin: '1rem 0' }}>Process</h3>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section id="cd-timeline" className="cd-container">
						{exerciseDetails &&
							exerciseDetails?.Tasks?.map((task:any, index:any) => (
								<TextCard
									key={task.id}
									copy={task && changeIdentities(task.description, child?.fullName,child?.gender)}
									common={{ background: shuffleItems(blocks) }}
									number={index + 1}
								/>
							))}
					</section>
					<h5 className="d-flex justify-content-center align-items-center my-5 mx-2">What to look for</h5>
								<p className="d-flex justify-content-center align-items-center " style={{padding:'3rem'}}>{parse(changeIdentities(exerciseDetails.whatToLookFor, childName, child?.gender))}</p>
					<section className="d-flex justify-content-center flex-column align-items-center">
						<div
							className="d-flex justify-content-center"
							style={{
								margin: matches ? ' 0 1rem' : '',
								padding:'2rem'
							}}
						>
							
							{exerciseDetails.tip && <TextCard
								only
								common={{
									background: '#D0E6A5',
									radius: '4rem',
									height: 'auto',
								}}
							>
								<h5>Pro tip</h5>
								<p>{parse(changeIdentities(exerciseDetails.tip, childName, child?.gender))}</p>
							</TextCard>}
						</div>
						<div className="mb-4" style={{marginBottom:'2rem !important'}}>
						{
								exerciseDetails?.toyLink ? (
									<CommonButton
										onClick={() => redirectToNewToy(exerciseDetails?.toyLink)}
										common={{
											width: '261px',
											height: '48px',
											background: '#FF7552',
											radius: '200px',
											margin: '1 auto',
											fontSize: '18px',
										}}
										command="BUY TOY"
									/>
								) : ''
							}
						</div>
						
					</section>
				</div>
			) : (
				<div className={classes.loading}>
					{errors ? (
						<Error errors={errors} />
					) :  (
						<div className={classes.loading}>
								<h4>Wait a moment ...</h4>
								<ClipLoader color={'#7FD6DD'} loading={true} size={50} />
							</div>
					)}
					{/* {
						loading ? (
							<div className={classes.loading}>
								<h4>Wait a moment ...</h4>
								<ClipLoader color={'#7FD6DD'} loading={true} size={50} />
							</div>
						) : ''
					} */}
				</div>
			)}
		</Fragment>
	);
};

export default CalendarDetails;
